import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthServiceService } from '../services/authService/auth-service.service';
import { map, take } from 'rxjs';


export const authGuard: CanActivateFn = (route, state) => {

	const router = inject(Router);
	const authService = inject(AuthServiceService);
	const token = localStorage.getItem('token');
	const sessionToken = localStorage.getItem('session_token');
	const companyId = localStorage.getItem('company_id');
	const requiredPermission =
		route.data?.['permission'] ?? route.routeConfig?.data?.['permission'];

	// Always allow public access to the job details page, regardless of login status
	const jobDetailMatch = state.url.match(/\/recruiter-dashboard\/jobs\/([a-zA-Z0-9-]+)(\?.*)?$/);
	if (jobDetailMatch && jobDetailMatch[1] !== 'create') {
		return true;
	}

	if (!token) {
		if (state.url.includes('company-onBoard') && sessionToken && companyId) {
			return true;
		}

		if (state.url.includes('recruiter')) {
			router.navigate(['/recruiter-auth']);
		} else if (state.url.includes('college-dashboard')) {
			router.navigate(['/college-auth']);
		} else {
			router.navigate(['/login'], { queryParams: { redirectUrl: state.url } });
		}
		return false;
	}

	return authService.permissions$.pipe(take(1), map((userPermissions: string[]) => {
		if (!requiredPermission) return true;
		const permissionsArray = Array.isArray(requiredPermission) ? requiredPermission : [requiredPermission];
		const hasAccess = permissionsArray.some(p => userPermissions.includes(p));
		if (!hasAccess) {
			router.navigate(['/access-denied']);
			return false;
		}
		return true;
	})
	);
};
